import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for sports transactions table.
 */
export default class tableSportsTransactionsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Getting partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            height: screen.width < 820 ? 400 : 0, // Set height based on screen width
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserId', // Column ID
                                    header: _('ID Usuario'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha'), // Localized column header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 150, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'TransactionId', // Column ID
                                    header: _('Transacción Id'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ticked Id', // Column ID
                                    header: _('Ticked Id'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeBalance', // Column ID
                                    header: 'Tipo', // Column header
                                    options: [
                                        // Options for the dropdown
                                        { id: '', value: _('Todos') },
                                        { id: '0', value: _('BET') },
                                        { id: '1', value: _('WIN') },
                                        { id: '2', value: _('REFUND') },
                                        { id: '3', value: _('LOSS') },
                                        { id: '4', value: _('BETCHECK') },
                                        { id: '5', value: _('NEWDEBIT') },
                                        { id: '6', value: _('NEWCREDIT') },
                                        { id: '7', value: _('CASHOUT') },
                                        { id: '8', value: _('STAKEDECREASE') },
                                        { id: '9', value: _('WINBONUS') },
                                        { id: '10', value: _('CODEBONUS') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Value', // Column ID
                                    header: _('Valor'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        // Number formatting
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                            ],
                            ready: function () {
                                // Event when the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show overlay message
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Getting partner ID from parameters
        grid = $$('datatable'); // Reference to the datatable instance
        var url = devConfig.geturlApi() + 'es/SportsTransactions/GetSportsTransactions?Partner=' + id_partner + '&'; // API URL for fetching sports transactions
        var filter = ''; // Filter string for API requests

        this.on(this.app, 'sportsTransactions:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String to build query parameters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Append partner ID to filter string
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data
            filter = string1; // Update filter variable
        });

        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event after sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event on item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
